<script>
    export default {
        props: [
            'name', 'type', 'enableCompare', 'enableGoal', 'initLang', 'initConfig','modelname'
        ],
        data: function () {
            return {
                lang: this.initLang,
                message: "",
                messageClass: "",
                messageIcon: "",
                messageTitle: "",
                messageText: [],
                goal: 0,
                widgetModel: "",
                goalDeltaPerc: 0,
                qualityLabel: "",
                qualityClass: "",
                valueMain: 0,
                valueMainTot: 0,
                valueCompare: 0,
                valueCompareTot: 0,
                valueDeltaPerc: 0,
                chartElement: null,
                chartCanvas: null,
                result: {},
                mainData: {},
                compareData: {},
                compareDeltaClass: "",
                config: {},
                formatter: null,
                locale: this.$parent.$parent.locale,
                widget: this.$parent.widget,
                loading: true,
            }
        },
        created: function () {
            var dashboardWidgetObject = this;

            dashboardWidgetObject.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        mounted: function () {
            var dashboardWidgetObject = this;

            dashboardWidgetObject.lang = $.extend({}, dashboardWidgetObject.$parent.$parent.lang, dashboardWidgetObject.$parent.lang, dashboardWidgetObject.lang);

            dashboardWidgetObject.initDefaults();

            Event.$on("mainFilterChanged", function (dashboardMainFilter) {
                dashboardWidgetObject.loading = true;
            });

            Event.$on("widgetFilterApplied", function (dashboardWidgetFilter, data) {
                setTimeout(function () {
                    $(".widget-alert").hide();
                }, 12000);
                if (dashboardWidgetFilter.widget == dashboardWidgetObject.widget && data[dashboardWidgetObject.name]) {
                    dashboardWidgetObject.parseResult(dashboardWidgetFilter, data);
                    dashboardWidgetObject.draw(dashboardWidgetFilter);
                    dashboardWidgetObject.loading = false;
                }
            });

            Event.$on("widgetFilterChanged", function (dashboardWidgetFilter) {
                if (dashboardWidgetFilter.widget == dashboardWidgetObject.widget) {
                    dashboardWidgetObject.loading = true;
                }
            });

            Event.$on("dashboardMounted", function () {
                Event.$emit('objectMounted', dashboardWidgetObject);
            });
        },
        methods: {
            format: function (number) {
                var dashboardWidgetObject = this;

                return dashboardWidgetObject.formatter.format(number).replace(/\D00$/, '');
            },
            parseResult: function(dashboardWidgetFilter, data) {
                    var dashboardWidgetObject = this;

                    dashboardWidgetObject.result = data[dashboardWidgetObject.name];
                    if (dashboardWidgetObject.result.series && dashboardWidgetObject.result.series[0]) {
                        dashboardWidgetObject.mainData = dashboardWidgetObject.result.series[0].data;
                    }
                    if (dashboardWidgetObject.result.series && dashboardWidgetObject.result.series[1]) {
                        dashboardWidgetObject.compareData = dashboardWidgetObject.result.series[1].data;
                    }

                    dashboardWidgetObject.messageText = [];
                    if(dashboardWidgetObject.mainData.length == 0 || dashboardWidgetObject.mainData == 0){
                        dashboardWidgetObject.messageTitle = dashboardWidgetObject.lang["Warning!"];
                        dashboardWidgetObject.messageClass = "alert-red";
                        //dashboardWidgetObject.messageIcon = "fa fa-warning";
                        dashboardWidgetObject.messageText.push(dashboardWidgetObject.lang["Main result has no data, please check your selection."]);
                    }
                    if(dashboardWidgetObject.enableCompare && (dashboardWidgetObject.compareData.length == 0 || dashboardWidgetObject.compareData == 0)){
                        dashboardWidgetObject.messageTitle = dashboardWidgetObject.lang["Warning!"];
                        dashboardWidgetObject.messageClass = "alert-yellow";
                        //dashboardWidgetObject.messageIcon = "fa fa-warning";
                        dashboardWidgetObject.messageText.push(dashboardWidgetObject.lang["Compare result has no data, please check your selection."]);
                    }
                    dashboardWidgetObject.showMessage();
            },
            showMessage: function(){
                var dashboardWidgetObject = this;

                if(dashboardWidgetObject.messageText.length > 0){
                    $(".widget-alert", dashboardWidgetObject.$el).remove();

                    dashboardWidgetObject.message = dashboardWidgetObject.messageText.join("\n");

                    var html = '';
                    html += '<div class="widget-alert ' + dashboardWidgetObject.messageClass + '">';
                    /* html += '   <h4>' + dashboardWidgetObject.messageTitle + '</h4>'; */
                    html += '   <p class="widget-alert-text">' + dashboardWidgetObject.message + '</p>';
                    html += '   <div class="widget-alert-close"><i class="fa fa-times"></i></div>';
                    html += '</div>';

                    /* var html = '';
                    html += '<div class="dashboard__widget-object-message alert ' + dashboardWidgetObject.messageClass + '">';
                    html += '   <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>';
                    html += '   <h4><i class="' + dashboardWidgetObject.messageIcon + '"></i> ' + dashboardWidgetObject.messageTitle + '</h4>';
                    html += '   <div class="dashboard__widget-object-message-text">' + dashboardWidgetObject.message + '</div>';
                    html += '</div>'; */

                    $(html).prependTo(dashboardWidgetObject.$el);
                }
            },
            initDefaults: function () {
                var dashboardWidgetObject = this;

                switch (dashboardWidgetObject.type) {
                    case 'number':
                        break;
                    case 'chart-sparkline':
                        dashboardWidgetObject.chartElement = $('.dashboard__widget-object-canvas', this.$el);
                        dashboardWidgetObject.config.object = $.extend(true, {}, {
                            width: '100%',
                            height: '70px',
                            barColor: 'rgb(38, 182, 232)',
                            negBarColor: 'rgb(38, 182, 232)',
                            lineColor: 'rgb(38, 182, 232)',
                            fillColor: 'rgba(255, 255, 255)',
                            spotColor: 'rgb(38, 182, 232)',
                            minSpotColor: 'rgb(38, 182, 232)',
                            maxSpotColor: 'rgb(38, 182, 232)',
                            highlightSpotColor: 'rgb(38, 182, 232)',
                            highlightLineColor: '#ddd',
                        });
                        dashboardWidgetObject.chartCanvas =
                            dashboardWidgetObject.chartElement.sparkline('html', dashboardWidgetObject.config.object);
                        break;
                    case 'chart-highcharts':
                        dashboardWidgetObject.chartElement = $('.dashboard__widget-object-canvas', this.$el).get(0);
                        dashboardWidgetObject.config.object = $.extend(true, {}, {
                            chart: {
                                renderTo: dashboardWidgetObject.chartElement,
                                height: 350,
                                zoomType: 'x',
                                style: {
                                    fontFamily: 'Gilroy'
                                }
                            },
                            credits: {
                                enabled: false
                            },
                            xAxis: [{
                                id: 'main',
                                crosshair: {
                                    snap: true
                                },
                                type: 'datetime',
                                labels: {
                                    rotation: 0,
                                    align: 'center',
                                    style: {
                                        color: 'rgb(38, 182, 232)',
                                    }
                                }

                            }, {
                                id: 'compare',
                                crosshair: {
                                    snap: true
                                },
                                tickLength: 0,
                                lineWidth: 0,
                                type: 'datetime',
                                labels: {
                                    rotation: 0,
                                    align: 'center',
                                    style: {
                                        color: 'rgb(241, 136, 81)'
                                    }
                                }
                            }],
                            tooltip: {
                                shared: true,
                            },
                            colors: [
                                'rgb(38, 182, 232)',
                                'rgb(232, 211, 200)',
                                'rgb(255, 159, 64)',
                                'rgb(255, 205, 86)',
                                'rgb(54, 162, 235)',
                                'rgb(153, 102, 255)',
                                'rgb(201, 203, 207)'
                            ],
                            plotOptions: {
                                line: {
                                    marker: {
                                        symbol: 'circle'
                                    }
                                },
                                area:{
                                    fillOpacity: 0.75
                                },
                                column: {},
                                pie: {
                                    allowPointSelect: true,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: false
                                    },
                                    showInLegend: true,
                                    size: '40%',
                                    point: {
                                        events: {
                                            legendItemClick: function (e) {
                                                var legendItem = this.name;

                                                $(dashboardWidgetObject.chartCanvas.series).each(function (j, f) {
                                                    $(this.data).each(function (k, z) {
                                                        if (z.name == legendItem) {
                                                            if (z.visible) {
                                                                z.setVisible(false);
                                                            } else {
                                                                z.setVisible(true);
                                                            }
                                                        }
                                                    });
                                                });

                                                e.preventDefault();
                                            }
                                        }
                                    }
                                },
                                series: {
                                    events: {
                                        legendItemClick: function (e) {
                                            if (this.xAxis.visible) {
                                                this.xAxis.update({visible: false});
                                            } else {
                                                this.xAxis.update({visible: true});
                                            }
                                        }
                                    }
                                }
                            }
                        });
                        dashboardWidgetObject.chartCanvas = Highcharts.chart(dashboardWidgetObject.config.object);
                        break;
                    case 'table':
                        dashboardWidgetObject.config.object = $.extend(true, {}, {
                            mark: true,
                            scrollX: true,
                            language: {
                                url: '/js/vendor/dataTables/lang/' + $("html").attr("lang") + '.json'
                            },
                            drawCallback: function (settings) {
                                $('.dt-button', '.dataTables_wrapper').removeClass("dt-button");
                            }
                        });
                        break;

                }
            },
            draw: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                switch (dashboardWidgetObject.type) {
                    case 'number':
                        dashboardWidgetObject.drawNumber(dashboardFilter);
                        break;
                    case 'chart-sparkline':
                        switch (dashboardWidgetObject.initConfig.object.type) {
                            case 'line':
                                dashboardWidgetObject.drawLineSparkline(dashboardFilter);
                                break;
                            case 'bar':
                                dashboardWidgetObject.drawBarSparkline(dashboardFilter);
                                break;
                            case 'pie':
                                dashboardWidgetObject.drawPieSparkline(dashboardFilter);
                                break;
                        }
                        break;
                    case 'chart-highcharts':
                        switch (dashboardWidgetObject.initConfig.object.chart.type) {
                            case 'area':
                                dashboardWidgetObject.drawAreaChart(dashboardFilter);
                                break;
                            case 'line':
                                dashboardWidgetObject.drawLineChart(dashboardFilter);
                                break;
                            case 'column':
                                dashboardWidgetObject.drawColumnChart(dashboardFilter);
                                break;
                            case 'bar':
                                dashboardWidgetObject.drawBarChart(dashboardFilter);
                                break;
                            case 'pie':
                                dashboardWidgetObject.drawPieChart(dashboardFilter);
                                break;
                            case 'sun':
                                dashboardWidgetObject.drawPieChart(dashboardFilter);
                                break;
                            case 'solidgauge':
                                dashboardWidgetObject.drawSolidgaugeChart(dashboardFilter);
                                break;
                        }
                        dashboardWidgetObject.chartCanvas = Highcharts.chart(dashboardWidgetObject.config.object);
                        break;
                    case 'table':
                        dashboardWidgetObject.drawTable(dashboardFilter);
                        break;
                }
            },
            drawAreaChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'area'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        yAxis: [{
                            reversedStacks:false}],
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }, {
                            min: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.compareRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }, {
                            xAxis: 'compare',
                            name: dashboardWidgetObject.lang['Compare'],
                            pointStart: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'area'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }
            },
            drawLineChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'line'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        yAxis: [{
                            reversedStacks:true}],
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }, {
                            min: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.compareRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }, {
                            xAxis: 'compare',
                            name: dashboardWidgetObject.lang['Compare'],
                            pointStart: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'line'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day',
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }
            },
            drawColumnChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'column'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }, {
                            min: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.compareRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }, {
                            xAxis: 'compare',
                            name: dashboardWidgetObject.lang['Compare'],
                            pointStart: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'column'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }
            },
            drawBarChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'bar'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }, {
                            min: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.compareRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }, {
                            xAxis: 'compare',
                            name: dashboardWidgetObject.lang['Compare'],
                            pointStart: moment.utc(dashboardFilter.compareRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'bar'
                        },
                        tooltip: {
                            xDateFormat: "%d/%m/%Y"
                        },
                        xAxis: [{
                            min: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            max: moment.utc(dashboardFilter.mainRangeEnd).valueOf(),
                            labels: {
                                format: '{value:%d/%m/%Y}'
                            }
                        }],
                        series: [{
                            xAxis: 'main',
                            name: dashboardWidgetObject.lang['Main'],
                            pointStart: moment.utc(dashboardFilter.mainRangeStart).valueOf(),
                            pointIntervalUnit: 'day'
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }

            },
            drawPieChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            events: {
                                load: function () {
                                    var labelMain = this.renderer.label(dashboardWidgetObject.lang['Main'], 0, 55).add();
                                    var labelCompare = this.renderer.label(dashboardWidgetObject.lang['Compare'], 0, 55).add();
                                    labelMain.attr({
                                        x: this.plotWidth * 1 / 5 - labelMain.width / 2 + 20
                                    });
                                    labelCompare.attr({
                                        x: this.plotWidth * 4 / 5 - labelCompare.width / 2
                                    });
                                }
                            }
                        },
                        legend: {
                            align: 'center',
                            useHTML: true,
                            labelFormatter: function () {
                                return this.name + ' ' + dashboardWidgetObject.format(this.y);
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main'],
                            showInLegend: true,
                            center: ['20%']
                        }, {
                            name: dashboardWidgetObject.lang['Compare'],
                            showInLegend: false,
                            center: ['80%']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'pie'
                        },
                        legend: {
                            useHTML: true,
                            labelFormatter: function () {
                                return this.name + ' ' + dashboardWidgetObject.format(this.y);
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main'],
                            center: ['20%']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }
            },
            drawSunChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            events: {
                                load: function () {
                                    var labelMain = this.renderer.label(dashboardWidgetObject.lang['Main'], 0, 55).add();
                                    var labelCompare = this.renderer.label(dashboardWidgetObject.lang['Compare'], 0, 55).add();
                                    labelMain.attr({
                                        x: this.plotWidth * 1 / 5 - labelMain.width / 2 + 20
                                    });
                                    labelCompare.attr({
                                        x: this.plotWidth * 4 / 5 - labelCompare.width / 2
                                    });
                                }
                            }
                        },
                        legend: {
                            align: 'center',
                            useHTML: true,
                            labelFormatter: function () {
                                return this.name + ' ' + dashboardWidgetObject.format(this.y);
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main'],
                            showInLegend: true,
                            center: ['20%']
                        }, {
                            name: dashboardWidgetObject.lang['Compare'],
                            showInLegend: false,
                            center: ['80%']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'pie'
                        },
                        legend: {
                            useHTML: true,
                            labelFormatter: function () {
                                return this.name + ' ' + dashboardWidgetObject.format(this.y);
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main'],
                            center: ['20%']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                }
            },
            drawSolidgaugeChart: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'solidgauge'
                        },
                        xAxis: {
                            crosshair: false
                        },
                        yAxis: {
                            reversedStacks:true,
                            lineWidth: 0,
                            minorTickInterval: null,
                            tickWidth: 0,
                            labels: {
                                enabled: false
                            },
                            min: 0,
                            max: 200
                        },
                        tooltip: {
                            enabled: false
                        },
                        pane: {
                            center: ['50%', '40%'],
                            size: '60%',
                            startAngle: 0,
                            endAngle: 360,
                            background: {
                                backgroundColor: '#f4f4f4',
                                innerRadius: '60%',
                                outerRadius: '100%',
                                shape: 'arc'
                            }
                        },
                        labels: {
                            items: [{
                                html: (dashboardWidgetObject.result.valueDeltaPerc >= 0 ? '▲ +' : '▼ ') +
                                    dashboardWidgetObject.format(dashboardWidgetObject.result.valueDeltaPerc) + '%',
                                style: {
                                    left: 0,
                                    top: 140,
                                    color: dashboardWidgetObject.result.valueDeltaPerc >= 0 ? '#00a65a' : '#dd4b39'
                                }
                            }]
                        },
                        plotOptions: {
                            solidgauge: {
                                dataLabels: {
                                    y: 20,
                                    verticalAlign: 'bottom',
                                    borderWidth: 0,
                                    useHTML: true,
                                    formatter: function () {
                                        var html = '';
                                        html += '<div class="text-center">';
                                        html += dashboardWidgetObject.format(this.y);
                                        html += '</div>';
                                        html += '<small class="text-center">';
                                        html += dashboardWidgetObject.lang['of'] + ' ' +
                                            dashboardWidgetObject.format(this.series.yAxis.max);
                                        html += '</small>';
                                        return html;
                                    }
                                }
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);
                } else {
                    $.extend(true, dashboardWidgetObject.config.object, {
                        chart: {
                            type: 'solidgauge'
                        },
                        xAxis: {
                            crosshair: false
                        },
                        yAxis: {
                            reversedStacks:true,
                            lineWidth: 0,
                            minorTickInterval: null,
                            tickWidth: 0,
                            labels: {
                                enabled: false
                            },
                            min: 0,
                            max: 200
                        },
                        tooltip: {
                            enabled: false
                        },
                        pane: {
                            center: ['50%', '40%'],
                            size: '60%',
                            startAngle: 0,
                            endAngle: 360,
                            background: {
                                backgroundColor: '#f4f4f4',
                                innerRadius: '60%',
                                outerRadius: '100%',
                                shape: 'arc'
                            }
                        },
                        plotOptions: {
                            solidgauge: {
                                dataLabels: {
                                    y: 20,
                                    verticalAlign: 'bottom',
                                    borderWidth: 0,
                                    useHTML: true,
                                    formatter: function () {
                                        var html = '';
                                        html += '<div class="text-center">';
                                        html += dashboardWidgetObject.format(this.y);
                                        html += '</div>';
                                        html += '<small class="text-center">';
                                        html += dashboardWidgetObject.lang['of'] + ' ' +
                                            dashboardWidgetObject.format(this.series.yAxis.max);
                                        html += '</small>';
                                        return html;
                                    }
                                }
                            }
                        },
                        series: [{
                            name: dashboardWidgetObject.lang['Main']
                        }]
                    }, dashboardWidgetObject.initConfig.object, dashboardWidgetObject.result);

                }
            },
            drawNumber: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    dashboardWidgetObject.valueMain = Number(dashboardWidgetObject.result.series[0].data);
                    dashboardWidgetObject.valueCompare = Number(dashboardWidgetObject.result.series[1].data);
                    dashboardWidgetObject.qualityLabel = dashboardWidgetObject.result.qualityLabel;
                    dashboardWidgetObject.qualityClass = dashboardWidgetObject.result.qualityClass;
                    dashboardWidgetObject.compareDeltaClass = dashboardWidgetObject.result.compareDeltaClass;

                    if (dashboardWidgetObject.valueCompare == 0.00 && dashboardWidgetObject.valueMain == 0.00) {
                        dashboardWidgetObject.valueDeltaPerc = 0.00;
                    } else if (dashboardWidgetObject.valueCompare != 0.00 && dashboardWidgetObject.valueMain == 0.00) {
                        dashboardWidgetObject.valueDeltaPerc = -100.00;
                    } else {
                        var delta = dashboardWidgetObject.valueMain - dashboardWidgetObject.valueCompare;
                        dashboardWidgetObject.valueDeltaPerc = (delta / dashboardWidgetObject.valueCompare) * 100;
                    }
                } else {
                    dashboardWidgetObject.valueMain = Number(dashboardWidgetObject.result.series[0].data);
                }


                if(dashboardWidgetObject.enableGoal){
                    dashboardWidgetObject.goal = Number(dashboardWidgetObject.result.goal ? dashboardWidgetObject.result.goal : dashboardWidgetObject.initConfig.object.goal);
                    if (dashboardWidgetObject.goal == 0.00 && dashboardWidgetObject.valueMain == 0.00) {
                        dashboardWidgetObject.goalDeltaPerc = 0.00;
                    } else if (dashboardWidgetObject.goal != 0.00 && dashboardWidgetObject.valueMain == 0.00) {
                        dashboardWidgetObject.valueDeltaPerc = -100.00;
                    } else {
                        dashboardWidgetObject.goalDeltaPerc = (dashboardWidgetObject.valueMain * 100) / dashboardWidgetObject.goal;
                    }
                }

            },
            drawTable: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                $(".dashboard__widget-object-main table", dashboardWidgetObject.$el).DataTable().destroy();
                if (dashboardWidgetObject.enableCompare) {
                    $(".dashboard__widget-object-compare table", dashboardWidgetObject.$el).DataTable().destroy();
                }
                dashboardWidgetObject.$nextTick(function () {
                    $("body > .modal--external-link").remove();

                    if (dashboardWidgetObject.enableCompare) {
                        $(".dashboard__widget-object-main table", dashboardWidgetObject.$el).DataTable($.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object));
                        $(".dashboard__widget-object-compare table", dashboardWidgetObject.$el).DataTable($.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object));
                    } else {
                        $(".dashboard__widget-object-main table", dashboardWidgetObject.$el).DataTable($.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object));
                    }

                    $(".external-link", dashboardWidgetObject.$el).on("click", function(){
                        $("body > .modal--external-link").remove();
                        var i = $(this).closest("tr").index();
                        $(this).attr("data-target", "#external-link_" + i);
                        var html = '';
                        html += '<div class="modal fade modal--external-link" role="dialog" aria-hidden="true" id="external-link_' + i + '">';
                        html += '    <div class="modal-dialog modal-lg">';
                        html += '        <div class="modal-content">';
                        html += '            <div class="modal-header">';
                        html += '                <h4 class="modal-title">';
                        html += '                    <a href="' + $(this).data("src") + '" target="_blank">';
                        html += '                       ' + $(this).data("title");
                        html += '                    </a>';
                        html += '                    <button type="button" class="close" data-dismiss="modal">&times;</button>';
                        html += '                </h4>';
                        html += '            </div>';
                        html += '            <div class="modal-body">';
                        html += '                <iframe src="' + $(this).data("src") + '" width="100%" height="100%"></iframe>';
                        html += '            </div>';
                        html += '        </div>';
                        html += '    </div>';
                        html += '</div>';
                        $(html).appendTo("body");
                    });
                });
            },
            drawLineSparkline: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    dashboardWidgetObject.valueDeltaPerc = dashboardWidgetObject.result.valueDeltaPerc;
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object)
                        );
                } else {
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object)
                        );
                }
            },
            drawBarSparkline: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                var $el = dashboardWidgetObject.chartElement;

                var values = dashboardWidgetObject.result.series[0].data.map(parseFloat);

                var parentWidth = $el.parent().width();
                var valueCount = values.length;
                var barSpacing = 1;

                var barWidth = Math.round((parentWidth - (valueCount - 1) * barSpacing) / valueCount);

                if (dashboardWidgetObject.enableCompare) {
                    dashboardWidgetObject.valueDeltaPerc = dashboardWidgetObject.result.valueDeltaPerc;
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {
                                barWidth: barWidth,
                                barSpacing: barSpacing
                            }, dashboardWidgetObject.initConfig.object)
                        );
                } else {
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {
                                barWidth: barWidth,
                                barSpacing: barSpacing
                            }, dashboardWidgetObject.initConfig.object)
                        );
                }
            },
            drawPieSparkline: function (dashboardFilter) {
                var dashboardWidgetObject = this;

                if (dashboardWidgetObject.enableCompare) {
                    dashboardWidgetObject.valueDeltaPerc = dashboardWidgetObject.result.valueDeltaPerc;
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object)
                        );
                } else {
                    dashboardWidgetObject.chartCanvas =
                        dashboardWidgetObject.chartElement.sparkline(
                            dashboardWidgetObject.result.series[0].data,
                            $.extend(true, dashboardWidgetObject.config.object, {}, dashboardWidgetObject.initConfig.object)
                        );
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/dashboards/dashboardWidgetObject.vue